const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']

// Swaps every Latin digit in a string for its Persian form: "12:30" becomes "۱۲:۳۰"
export const toFaDigits = (value: string | number): string => String(value).replace(/[0-9]/g, digit => PERSIAN_DIGITS[Number(digit)])

// Turns Persian (۰-۹) and Arabic (٠-٩) digits back into Latin ones, so a phone number
// typed on a Persian keyboard validates and dials like any other.
export const toLatinDigits = (value: string): string => value
    .replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x06F0))
    .replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x0660))

const plainNumber = new Intl.NumberFormat('fa-IR', { useGrouping: true })

// A whole number in Persian digits with Persian grouping: 1200 becomes "۱٬۲۰۰"
export const formatNumber = (value: number): string => plainNumber.format(value)

const wholeDollars = new Intl.NumberFormat('fa-IR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
const withCents = new Intl.NumberFormat('fa-IR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const toCents = (amount: number): number => Math.round(amount * 100)

// Menu prices drop the cents when there are none: "۱۱ دلار", "۴٫۷۵ دلار"
export const formatPrice = (amount: number): string => `${(toCents(amount) % 100 === 0 ? wholeDollars : withCents).format(amount)} دلار`

// Order totals always show cents: "۱۱٫۰۰ دلار"
export const formatMoney = (amount: number): string => `${withCents.format(amount)} دلار`

// Persian nouns do not change after a number: "۳ عدد"
export const pluralize = (count: number, singular: string, plural = singular): string => `${formatNumber(count)} ${count === 1 ? singular : plural}`

export const firstName = (name: string): string => name.trim().split(/\s+/)[0] ?? ''

// ["نان چاودار", "باگت", "کروسان"] becomes "نان چاودار، باگت و کروسان"
export const joinNames = (names: Array<string>): string => {
    if (names.length <= 1) return names[0] ?? ''

    return `${names.slice(0, -1).join('، ')} و ${names[names.length - 1]}`
}
